//contains the default states of the control variables
var appControlObj = {
	appState:0,
	newProduct: false,
	openProduct: false,
	editProduct: false,
	selectedProduct: null,
	addNewBatch: false,
	newBatchType: 0,
	countrySelected: null,
	productsOverlay: false,
}

export const getState = (stateVar) =>{


	if(localStorage.getItem('appControlObj')){

		var appControlObjAux = localStorage.getItem('appControlObj'); 

		var parseObj = JSON.parse(appControlObjAux); 

		return 	parseObj[stateVar];
	}
	else{
		return 0;
	}
	

}

export const setState = (stateVar,state) =>{

	
	if(localStorage.getItem('appControlObj')){

		var appControlObjAux = localStorage.getItem('appControlObj'); 
		var parseObj = JSON.parse(appControlObjAux); 

		parseObj[stateVar] = state;

		localStorage.setItem('appControlObj', JSON.stringify(parseObj));

	}
	else{

		localStorage.setItem('appControlObj', JSON.stringify(appControlObj));	
	}

	
}



export const productImg = {

	"Portugal":{

		"img1":{
			"url": "/img/Portugal/Alheira.png",
			"cover": "/img/Portugal/alheira_cover.png",
			"fluxogram": "alheiraChart1.png",
			"id" : "Portugal_1",
			"name": "Alheira",
			"description":"Traditional fermented meat product commonly made of poultry and pig meat, intended to be eaten cooked. Alheira de Vinhais and Alheira de Mirandela are PDO variants, yet alheiras are produced in other regions of Portugal."
			
		},
		"img2":{
			"url": "/img/Portugal/Queijo.png",
			"cover": "/img/Portugal/queijo_cover.jpg",
			"fluxogram": "queijoChart1.png",
			"id": "Portugal_2",
			"name": "Queijo de Cabra",
			"description": "Semi-hard cheese made of goat’s raw milk without starter culture and matured for 60 days. Transmontano cheese is the PDO label."
		},
		"partners":{
			"url": ["/img/Portugal/cimo.png"]
		}
	},
	"Spain":{
		"img1":{
			"url": "/img/Spain/SPAIN_SALSICHON.png",
			"cover": "/img/Spain/salsichon_cover.jfif",
			"fluxogram": "salsichonChart.png",
			"id": "Spain_1",
			"name": "Salchichón",
			"description":"Product of large tradition of elaboration in rural areas, especially appreciated in Spain for its mild and singular taste conferred by the use of natural spices for its elaboration. This product is made of pig meat and bacon, salt, and a selection of peppers, stuffed into natural intestinal pork casings to be cured and fermented."
		},
		"img2":{
			"url": "/img/Spain/SPAIN_QUESO.png",
			"cover": "/img/Spain/queso_cover.jfif",
			"fluxogram": "quesoChart.png",
			"id": "Spain_2",
			"name": "Queso Manchego",
			"description":"Cheeses of intense flavour and aroma conferred by the absence of milk heat-treatment, with ripening times generally of up to 60 days. In a country of large tradition of hard cheeses, this kind of cheese is appreciated by the regional Andalusian consumers due to the strong sensorial properties of goat milk."
		},
		"partners":{
			"url": ["/img/Spain/uco.png"]
		} 
	},
	"France":{
		"img1":{
			"url":"/img/France/FRANCE_CHEESE.png",
			"cover": "/img/France/cheese_cover.jpg",
			"fluxogram": "cheeseChart.png",
			"id": "France_1",
			"name": "Camembert de Normandy",
			"description":"PDO Camembert de Normandie is a soft raw milk cheese with a bloomy rind (white mould). It is made from a curd that is only slightly divided, moulded in five successive layers with a rest period between each one and drained spontaneously."
		},
		"partners":{
			"url": ["/img/France/anses.png","/img/France/cniel.png"]
		}
	},
	"Italy":{
		"img1":{
			"url": "/img/Italy/ITALY_SAUSAGE.png",
			"cover": "/img/Italy/sausage_cover.jfif",
			"fluxogram": "salamiChart.png",
			"id": "Italy_1",
			"name": "Emilia-Romagna salami",
			"description":"Salame gentile is an artisanal salame made with pig meat, salt, pepper, garlic and wine ripened in cellar for 3 to 6 months"
		},
		"img2":{
			"url": "/img/Italy/ITALY_CHEESE.png",
			"cover": "/img/Italy/cheese_cover.jfif",
			"fluxogram": "cheeseChart.png",
			"id": "Italy_2",
			"name": "Squacquerone di Romagna",
			"description":"Squacquerone di Romagna is a PDO cow's milk cheese, made with pasteurized milk, salt, rennet and starter cultures. It is very soft due to the high water content. The colour is white and the taste notes are typically lactic, with a sweet-sour taste."
		},
		"partners":{
			"url": ["/img/Italy/unibo.png"]
		}
	},
	"Greece":{
		"img1":{
			"url": "/img/Greece/GREECE_SAUSAGE.png",
			"cover": "/img/Greece/sausage_cover.jfif",
			"fluxogram": "noumbouloChart.png",
			"id": "Greece_1",
			"name": "Noumboulo",
			"description":"Traditional smoked cold cuts made from whole pork tenderloin, cured with salt and spices, and marinated in wine.  It is then stuffed in natural intestine, usually with a strip of fat, and smoked over a mixture of herbs."
		},
		"img2":{
			"url": "/img/Greece/GREECE_CHEESE.png",
			"cover": "/img/Greece/cheese_cover.jfif",
			"id": "Greece_2",
			"fluxogram": "katikiChart.png",
			"name": "Katiki Domokou",
			"description":"Traditional soft cheese with low fat content with protected designation of origin (Domoko).  It is made of goat and sheep’s pasteurized milk that curdles without rennet and is drained in bags made of cloth."	
		},
		"partners":{
			"url": ["/img/Greece/aua.png"]
		}
	},
	"Morocco":{
		"img1":{
			"url": "/img/Morocco/MOROCCO_SAUSAGE.png",
			"cover": "/img/Morocco/sausage_cover.jpg",
			"fluxogram": "merguezChart.png",
			"id": "Morocco_1",
			"name": "Merguez",
			"description":"Typical spicy fresh sausage made of lamb, beef, or a mixture of both types of meat. Merguez sausage does not undergo a fermentation or drying process. It is usually eaten cooked, fried, or barbecued. It is produced in all of the Maghreb regions."
		},
		"img2":{
			"url": "/img/Morocco/MOROCCO_CHEESE.png",
			"cover": "/img/Morocco/cheese_cover.jpg",
			"fluxogram": "jbenChart.png",
			"id": "Morocco_2",
			"name":"Moroccan Jben",
			"description":"Moroccan traditional jben cheese is made of goat's raw milk with no added starter cultures or with pasteurized milk and starter cultures. It is commonly consumed within 10 to 20 days after production."
		},
		"partners":{
			"url": ["/img/Morocco/uiz.png"]
		}
	},
	"Tunisia":{
		"img1":{
			"url": "/img/Tunisia/TUNISIA_SAUSAGE.png",
			"cover": "/img/Tunisia/sausage_cover.jfif",
			"fluxogram": "merguezChart.png",
			"id": "Tunisia_1",
			"name":"Dry Merguez",
			"description":"Dry Merguez are naturally fermented dry sausages consumed cooked in different Tunisian dishes.  This ethnic traditional product is made of beef/lamb meat."
		},
		"img2":{
			"url":"/img/Tunisia/TUNISIA_MEAT.png",
			"cover": "/img/Tunisia/TUNISIA_MILK.png",
			"fluxogram": "kaddidChart.png",	
			"id": "Tunisia_2",
			"name":"Kaddid",
			"description":"Kaddid is a traditional Tunisian product prepared from salted, seasoned and dried meat (sheep, beef, goat, etc.). Cooked Kaddid is included in different traditional Tunisian dishes."
		}, 
		"img3":{
			"url": "/img/Tunisia/TUNISIA_MILK.png",
			"cover": "/img/Tunisia/milk_cover.jpg",
			"fluxogram": "lebenChart.png",
			"id": "Tunisia_3",
			"name": "Leben",
			"description":"Traditional fermented milk obtained by spontaneous fermentation of raw milk at room temperature. It is a sour and skim refreshing beverage, widely consumed because of its nutritional values and organoleptic properties."
		},
		"partners":{
			"url": ["/img/Tunisia/uma.png"]
		}
	},
}

//Infor for Form batch Data
export const GeneralData = [

	{
		"Product":{
			"key": "Product",
			"label": "Product Name",
			"type": "select",
			"options":[],
			"placeholder": "Select value",
			"required": true		
		},
		"BatchSize":{
			"key": "BatchSize",
			"label": "Batch Size",
			"type": "number",
			"placeholder": "Enter value",
			"required": true		
		},
		"Trial":{
			"key": "Trial",
			"label": "Trial",
			"type": "select",
			"options":[
				{"value": "Yes"},
				{"value": "No"}

			],
			"placeholder": "Select value",
			"required": true		
		}
	},
	{
		"BatchID":{
			"key": "BatchID",
			"label": "Batch ID",
			"type": "string",
			"placeholder": "Enter value",
			"required": true		
		},
		"NumberOfSamples":{
			"key": "NumberOfSamples",
			"label": "Number of samples",
			"type": "number",
			"placeholder": "Enter value",
			"required": true		
		},
		"ProductionDate":{
			"key": "ProductionDate",
			"label": "Production Date",
			"type": "date",
			"placeholder": "",
			"required": true		
		}
	}	
];

export const MicrobiologyData = [{
	"Mesophiles":{
		"key": "Mesophiles",
		"keyMin" : "Mesophiles_Min",
		"keyMax" : "Mesophiles_Max",
		"label": "Mesophiles",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": true		
	},
	"LAB":{
		"key": "LAB",
		"keyMin" : "LAB_Min",
		"keyMax" : "LAB_Max",
		"label": "LAB",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},
	"Coliforms":{
		"key": "Coliforms",
		"keyMin" : "Coliforms_Min",
		"keyMax" : "Coliforms_Max",
		"label": "Coliforms",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},
	"E_coli":{
		"key": "E_coli",
		"keyMin" : "E_coli_Min",
		"keyMax" : "E_coli_Max",
		"label": "E. coli",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},
	"Staphylococcus":{
		"key": "Staphylococcus", //Staphylocci
		"keyMin" : "Staphylococcus_Min",
		"keyMax" : "Staphylococcus_Max",
		"label": "Staphylococcus",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},
	"Bacillus_cereus":{
		"key": "Bacillus_cereus",
		"keyMin" : "Bacillus_cereus_Min",
		"keyMax" : "Bacillus_cereus_Max",
		"label": "Bacillus cereus",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},	
	"Salmonella":{
		"key": "Salmonella",
		"keyMin" : "Salmonella_Min",
		"keyMax" : "Salmonella_Max",
		"label": "Salmonella",
		"type": "select",
		"options":[
			{"value": "0"},
			{"value": "1"}

		],
		"placeholder": "Enter a value",
		"units": "(0-neg, 1-pos)",
		"required": false		
	},
	"ListeriaAbs":{
		"key": "ListeriaAbs",
		"keyMin" : "ListeriaAbs_Min",
		"keyMax" : "ListeriaAbs_Max",
		"label": "Listeria",
		"type": "select",
		"options":[
			{"value": "0"},
			{"value": "1"}

		],
		"placeholder": "Enter a value",
		"units": "(0-neg, 1-pos)",
		"required": false		
	},
	"S_aureus":{
		"key": "S_aureus",
		"keyMin" : "S_aureus_Min",
		"keyMax" : "S_aureus_Max",
		"label": "S. aureus",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},	
	"Listeria_Counts":{
		"key": "Listeria_Counts",
		"keyMin" : "Listeria_Counts_Min",
		"keyMax" : "Listeria_Counts_Max",
		"label": "L. monocytogenes",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false		
	},
	"C_perfringens":{
			"key": "C_perfringens",
			"keyMin" : "C_perfringens_Min",
			"keyMax" : "C_perfringens_Max",
			"label": "C. perfringens",
			"type": "text",
			"placeholder": "Enter a value",
			"units": "(log CFU/g)",
			"required": false		
	},
	"Enterobacteriaceae":{
			"key": "Enterobacteriaceae",
			"keyMin" : "Enterobacteriaceae_Min",
			"keyMax" : "Enterobacteriaceae_Max",
			"label": "Enterobacteriaceae",
			"type": "text",
			"placeholder": "Enter a value",
			"units": "(log CFU/g)",
			"required": false
	},
	"Yeasts":{
		"key": "Yeasts",
		"keyMin" : "Yeasts_Min",
		"keyMax" : "Yeasts_Max",
		"label": "Yeasts",
		"type": "text",
		"placeholder": "Enter a value",
		"units": "(log CFU/g)",
		"required": false
	}
}
];



export const NutritionalData = [
	{
		"Moisture":{
			"key": "Moisture",
			"keyStd": "Moisture_Std",
			"label": "Moisture",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Energy_Kcal":{
			"key": "Energy_Kcal",
			"keyStd": "Energy_Kcal_Std",
			"label": "Energy",
			"type": "text",
			"placeholder": "Enter value",
			"units":"(kcal/100 g)",
			"required": false		
		},
		"Protein":{
			"key": "Protein",
			"keyStd": "Protein_Std",
			"label": "Protein",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Fat":{
			"key": "Fat",
			"keyStd": "Fat_Std",
			"label": "Fat",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"SatFat":{
			"key": "SatFat",
			"keyStd": "SatFat_Std",
			"label": "Sat_Fat",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Carbohydrates":{
			"key": "Carbohydrates",
			"keyStd": "Carbohydrates_Std",
			"label": "Carbohydrates",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Sugars":{
			"key": "Sugars",
			"keyStd": "Sugars_Std",
			"label": "Sugars",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Fibre":{
			"key": "Fibre",
			"keyStd": "Fibre_Std",
			"label": "Fibre",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"Salt":{
			"key": "Salt",
			"keyStd": "Salt_Std",
			"label": "Salt",
			"type": "text",
			"placeholder": "Enter value",
			"units": "(%)",
			"required": false		
		},
		"pH":{
			"key": "pH",
			"keyStd": "pH_Std",
			"label": "pH",
			"type": "text",
			"placeholder": "Enter value",
			"units": "-",
			"required": false		
		},
		"aw":{
			"key": "aw",
			"keyStd": "aw_Std",
			"label": "aw",
			"type": "text",
			"placeholder": "Enter value",
			"units": "-",
			"required": false		
		}
	}
];

export const UserData = [
	
	{
		"firstName":{
			"key": "firstName",
			"label": "First Name",
			"type": "text",
			"placeholder": "",
			"required": true,		
		},
		"email":{
			"key": "email",
			"label": "Email",
			"type": "text",
			"placeholder": "",
			"required": true,
			"disabled": true		
		},
		"company":{
			"key": "company",
			"label": "Company",
			"type": "text",
			"placeholder": "",
			"required": true,
			"disabled": true		
		}
	},
	{
		"lastName":{
			"key": "lastName",
			"label": "Last Name",
			"type": "text",
			"placeholder": "",
			"required": true		
		},
		"username":{
			"key": "username",
			"label": "Username",
			"type": "text",
			"placeholder": "",
			"required": true		
		},
		"role":{
			"key": "role",
			"label": "Role",
			"type": "text",
			"placeholder": "",
			"required": true,
			"disabled": true	
		}	
	}	
];